export default "__VITE_ASSET__fqOHXALH__"